import { render, staticRenderFns } from "./Upload.vue?vue&type=template&id=4c295c6d&scoped=true"
import script from "./Upload.vue?vue&type=script&lang=js"
export * from "./Upload.vue?vue&type=script&lang=js"
import style0 from "./Upload.vue?vue&type=style&index=0&id=4c295c6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c295c6d",
  null
  
)

export default component.exports